<template>
  <div class="flex flex-col">
    <div class="mb-3 text-lg font-semibold text-gray-700 text-center">
      Buy <span class="text-primary font-bold">X</span> for the price of <span class="text-primary font-bold">Y</span>
    </div>
    <div class="flex space-x-2.5">
      <v-text-field label="X" type="number" :value="x" outlined dense hide-details @input="xChange" />
      <v-text-field label="Y" type="number" :value="y" outlined dense hide-details @input="yChange" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'X4y',
  props: {
    x: {
      type: Number,
      default: 0,
    },
    y: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    /**
     * @param {InputEvent} e
     */
    xChange(val) {
      this.$emit('update:x', val || 0)
    },
    /**
     * @param {InputEvent} e
     */
    yChange(val) {
      this.$emit('update:y', val || 0)
    },
  },
}
</script>
